import {
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Table,
  Button,
  Link as ChakraLink,
} from "@chakra-ui/react";
import Dinero from "dinero.js";
import { KYDBatchPayout } from "@common/interfaces/KYDOrganization";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { useCallback } from "react";
import actions from "../../../src/actions";

export const PayoutsTable = ({
  payouts,
  ...props
}: {
  payouts: KYDBatchPayout[];
}) => {
  const handleDownloadPayoutCSV = useCallback(async (payout_id: string) => {
    const { url } = await actions.ADMIN.fetchPayoutDetailsReport({
      payout_id,
    });
    // The response from fetchPayoutDetailsReport is an S3 URL
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.download = `payout-${payout_id}.csv`;
    a.click();
  }, []);

  return payouts && payouts.length > 0 ? (
    <Table {...props}>
      <Thead>
        <Tr>
          <Th>Payout Date</Th>
          <Th>Events</Th>
          <Th>Gross Payout</Th>
          <Th>Holds</Th>
          <Th>Net Payout</Th>
          <Th></Th>
        </Tr>
      </Thead>
      <Tbody>
        {payouts.map((payout) => (
          <Tr key={payout.id} cursor="pointer" _hover={{ bg: "gray.50" }}>
            <Td zIndex={2}>
              <ChakraLink
                as={Link}
                to={`/payouts/${payout.id}`}
                w="100%"
                h="100%"
                _hover={{ textDecoration: "none" }}
              >
                <Text>{dayjs(payout.created_at).format("MMMM D, YYYY")}</Text>
              </ChakraLink>
            </Td>
            <Td zIndex={2}>
              <ChakraLink
                as={Link}
                to={`/payouts/${payout.id}`}
                w="100%"
                h="100%"
                _hover={{ textDecoration: "none" }}
              >
                <Text>{payout.events_count || "-"}</Text>
              </ChakraLink>
            </Td>
            <Td zIndex={2}>
              <ChakraLink
                as={Link}
                to={`/payouts/${payout.id}`}
                w="100%"
                h="100%"
                _hover={{ textDecoration: "none" }}
              >
                <Text>
                  {Dinero({
                    amount: payout.total.amount,
                    currency: "USD",
                  })
                    .add(
                      Dinero({
                        amount: payout.hold.amount,
                        currency: "USD",
                      })
                    )
                    .toFormat() || "-"}
                </Text>
              </ChakraLink>
            </Td>
            <Td zIndex={2}>
              <ChakraLink
                as={Link}
                to={`/payouts/${payout.id}`}
                w="100%"
                h="100%"
                _hover={{ textDecoration: "none" }}
              >
                <Text>
                  {Dinero({
                    amount: payout.hold.amount,
                    currency: "USD",
                  }).toFormat() || "-"}
                </Text>
              </ChakraLink>
            </Td>
            <Td zIndex={2}>
              <ChakraLink
                as={Link}
                to={`/payouts/${payout.id}`}
                w="100%"
                h="100%"
                _hover={{ textDecoration: "none" }}
              >
                <Text>
                  {Dinero({
                    amount: payout.total.amount,
                    currency: "USD",
                  }).toFormat() || "-"}
                </Text>
              </ChakraLink>
            </Td>
            <Td zIndex={2}>
              {/* <Button
                as={Link}
                to={`/payouts/${payout.id}`}
                variant="outline"
                py={4}
                px={4}
                size="sm"
                borderRadius={"10px"}
                backgroundColor="white"
                color="black"
              >
                View Payouts Details
              </Button> */}
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDownloadPayoutCSV(payout.id);
                }}
                variant="outline"
                size="sm"
                py={4}
                px={4}
                borderRadius={"10px"}
                backgroundColor="black"
                color="white"
                ml={2}
              >
                Download
              </Button>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  ) : (
    <Text color="gray.500" fontSize="sm">
      No payouts
    </Text>
  );
};

export default PayoutsTable;
